export const CENSUS_ONBOARDING = 'census-onboarding'
/** @deprecated Use CENSUS_ONBOARDING instead */
export const CUSTOMER_ONBOARDING = CENSUS_ONBOARDING
export const CENSUS_TEMPLATE_CREATE = 'census-template/create'
export const CENSUS_TEMPLATE_EDIT = 'census-template/edit'
export const CENSUS_TEMPLATE_VIEW = 'census-template/view'
export const ELIGIBLE_RULES_CREATE = 'eligible-rules/create'
export const ELIGIBLE_RULES_EDIT = 'eligible-rules/edit'
export const ELIGIBLE_RULES_VIEW = 'eligible-rules/view'
